<script>
/** example
 *  <editable-table
 *    title="Table Name",
 *    column-names="['a',{name:'b',editable:true},'c']"
 *    rows="[['a','b','c'],['a','b','c']]"
 *    save= '(indexOfRow,key,value)=>bool'
 *   />
 */
const props = {
  title: {
    require: false,
    type: String,
    default: ""
  },
  save: {
    require: true,
    type: Function //(rowIndex,key,value)->boolean
  },
  columnNames: {
    require: true,
    type: Array //array of String
  },
  rows: {
    require: true,
    type: Array //[[String]]
  }
};

import EditableRow from "./EditableRow";
const components = {
  "editable-row": EditableRow
};
function rowSave(rowIndex, columnIndex, value) {
  return this.save(rowIndex, columnIndex, value);
}
let methods = {
  onSave: function(rowIndex) {
    return rowSave.bind(this, rowIndex);
  }
};
const computed = {};
function data() {
  return {};
}

export default {
  components,
  data,
  computed,
  props,
  methods
};
</script>

<template>
  <table border="1">
    <caption v-if="title!=''">{{title}}</caption>
    <tr>
      <th v-for="key in columnNames" :key="key.name || key">{{key.name || key}}</th>
    </tr>
    <editable-row
      :column-names="columnNames"
      v-for="(row,index) in rows"
      :key="`row-${index}`"
      :values="row"
      :save="onSave(index)"
    />
  </table>
</template>
<style scoped>
table {
  padding: 2ex 0;
  flex: 0;
  min-width: 70%;
}
caption {
  text-align: center;
  font: 4ex bold;
  color: black;
}
th {
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// EditableTable.vue?37ac844f